module.exports = __webpack_public_path__ + "img/pegawai.c6a2afd7.png";